var render = function render(){var _vm=this,_c=_vm._self._c;return _c('http-patch-button',_vm._g(_vm._b({attrs:{"value":_vm.patches,"href":_vm.url,"version":"v2"},on:{"http4xx":_vm.onError}},'http-patch-button',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }